// Date pickers supply local dates; stored trial date fields are YYYY-MM-DD.
export const trialDateString = (value) => {
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return "";
    return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, "0")}-${String(value.getDate()).padStart(2, "0")}`;
  }
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return "";
  const date = new Date(`${value}T00:00:00Z`);
  return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value
    ? value : "";
};

export const trialDueDateEnd = (dueDate) => {
  const day = trialDateString(dueDate);
  if (!day) return null;
  const end = new Date(`${day}T00:00:00Z`);
  end.setUTCDate(end.getUTCDate() + 1);
  return end.toISOString().slice(0, 10);
};

export const withTrialDueDateEnd = (event) => {
  const props = event.extendedProps || {};
  const end = props.Activity === "ยืมเครื่อง" && trialDueDateEnd(props.DueDate);
  // Derive from DueDate, never from end: old and newly saved cases stay stable.
  return end ? { ...event, allDay: true, end } : event;
};
